module.exports = __webpack_public_path__ + "static/mezap-69f80db6812417b450c81259ff9e3327.gif";